export const getAttrValue=(arr,key)=>{
    let obj = arr.find(fl => fl.attribute_code === key)
    return obj!==undefined && obj.value!==undefined && obj.value
}